import { create } from 'zustand';
import type { ApplicationSession, Position, Submission } from '../services/careers/types';

export interface SelectedCareerFile {
  key: string; fieldId: string; file: File; id?: string;
  state: 'selected' | 'uploading' | 'verified' | 'failed';
}
export interface CareersApplicationDraft {
  name: string; email: string; phone: string; additionalText: string;
  answers: Record<string, string>; privacy: boolean; website: string;
  files: SelectedCareerFile[]; session?: ApplicationSession; submission?: Submission; position?: Position;
  busy: boolean; locked: boolean; success: boolean; error: string; stale: boolean;
}
export const emptyCareersDraft: CareersApplicationDraft = {
  name: '', email: '', phone: '', additionalText: '', answers: {}, privacy: false, website: '', files: [],
  busy: false, locked: false, success: false, error: '', stale: false,
};
interface CareersApplicationState {
  drafts: Record<string, CareersApplicationDraft>;
  update: (roleId: string, patch: Partial<CareersApplicationDraft>) => void;
  complete: (roleId: string) => void;
}
// Memory only: File objects and private applicant data must never go into localStorage.
// Keep upload sessions and retry payloads together with answers, including while the drawer is closed.
export const useCareersApplicationStore = create<CareersApplicationState>(set => ({
  drafts: {},
  update: (roleId, patch) => set(state => ({ drafts: { ...state.drafts, [roleId]: { ...(state.drafts[roleId] ?? emptyCareersDraft), ...patch } } })),
  complete: roleId => set(state => ({ drafts: { ...state.drafts, [roleId]: { ...emptyCareersDraft, success: true } } })),
}));
